import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

const WarningBanner: React.FC = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-red-600/95 via-orange-600/95 to-red-600/95 backdrop-blur-sm border-b border-red-500/30 shadow-lg">
      <div className="container mx-auto px-4 py-1">
        <div className="flex items-center justify-center space-x-3 text-center">
          <FaExclamationTriangle className="text-yellow-300 flex-shrink-0 text-lg animate-pulse" />
          <p className="text-sm font-semibold text-white leading-relaxed">
            JEUX D'ARGENT ET DE HASARD PEUVENT ÊTRE DANGEREUX: PERTES D'ARGENT, CONFLITS FAMILIAUX, ADDICTION.{' '}
            RETROUVEZ NOS CONSEILS SUR{' '}
            <a 
              href="https://www.joueurs-info-service.fr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:text-yellow-300 transition-colors font-bold"
            >
              JOUEURS-INFO-SERVICE.FR
            </a>
            {' '}(09 74 75 13 13 - APPEL NON SURTAXÉ)
          </p>
        </div>
      </div>
    </div>
  );
};

export default WarningBanner;

